import { useState, useEffect } from "react";
import { CustomProperty } from "winslow-core";
import { GenericSelect, GenericSelectOption } from "../../shared/GenericSelect";

type AppCustomPropertyRadioProps = {
    customProperty: CustomProperty;
    data: any;
    validate: boolean
    onChange: (label: string, data: any) => void;
}

export const AppCustomPropertyRadio = ({customProperty, data, validate, onChange} : AppCustomPropertyRadioProps) => {

    const [choice, setChoice] = useState<string>(data ? data : JSON.parse(customProperty.settings || "{}").default || "");

    useEffect(() => {
        onChange(customProperty.label, choice);
    }, [choice]);

    const settings = JSON.parse(customProperty.settings || "{}");

    return (
        <div className="app-custom-property-radio">
        
            {settings.choices.map((option: string, index: number) => {
                return (
                    <div 
                        key={"radio-" + index}
                        className="app-custom-property-radio-choice"
                    >
                        <input 
                            type="radio"
                            name={customProperty.label}
                            checked={choice === option}
                            onChange={(event) => {
                                setChoice(option);
                            }}
                        />
                        {option}
                    </div>
                )
                })
            }
            
        </div>
    )
}
